<div class="webinar-data-container">
  <form [formGroup]="range">
    <div class="row gx-3 gy-2 align-items-end filter-row">
      <div class="col-lg-3 col-md-6">
        <mat-form-field appearance="outline">
          <mat-label>Webinar Room</mat-label>
          <mat-select formControlName="webinarRoom">
            <mat-option *ngFor="let webinarRoom of webinarRooms" [value]="webinarRoom.webinarRoomId">
              {{ webinarRoom.roomName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-lg-3 col-md-6">
        <mat-form-field appearance="outline">
          <mat-label>Completed Date</mat-label>
          <mat-date-range-input [rangePicker]="picker" [max]="today">
            <input matStartDate matInput formControlName="start" placeholder="Start date" />
            <input matEndDate matInput formControlName="end" placeholder="End date" />
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
      </div>

      <div class="col-lg-3 col-md-6">
        <mat-form-field appearance="outline">
          <mat-label>Status</mat-label>
          <mat-select formControlName="status" multiple>
            <mat-option *ngFor="let status of statuses" [value]="status.id">
              {{ status.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

     <div class="col-lg-2 col-md-3 col-sm-6 d-flex justify-content-end">
      <button class="btn-get-data" (click)="GetData()" [disabled]="!range.valid">
        <mat-icon class="btn-icon">search</mat-icon> GET DATA
      </button>
    </div>
    </div>
  </form>

  <div class="row mt-3">
    <div class="col-md-6">
      <span *ngIf="historicalData?.length > 0">
        <button type="button" class="host-cta host-cta--ghost" (click)="accordion.openAll()">Expand All</button>
        <button type="button" class="host-cta host-cta--ghost" (click)="accordion.closeAll()">Collapse All</button>
      </span>
      <div *ngIf="historicalData?.length === 0" class="no-data-msg">
        **No webinars found as per your filter selection.
      </div>
    </div>
    <div class="col-md-6 text-end" *ngIf="historicalData?.length > 0">
      <span class="summary-text">Total Sales: {{ totalCost | currency }}</span><br />
      <span class="summary-text">Total Webinars: {{ historicalData.length }}</span>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-12">
      <mat-accordion multi *ngIf="historicalData">
        <mat-expansion-panel *ngFor="let webinar of historicalData; let i = index" [ngClass]="{
    completed: webinar.status === 'Completed',
    open: webinar.status === 'Open',
            closed: webinar.status === 'Closed'
          }">
          <mat-expansion-panel-header>
            <div class="panel-header">
              <div class="webinar-copy">
                <div class="webinar-name">{{ webinar.webinarName }}</div>
                <div class="webinar-date">
                  <ng-container *ngIf="webinar.status === 'Completed' && webinar.closeDateTime; else startDateLabel">
                    {{ webinar.closeDateTime | date: 'mediumDate' }}
                  </ng-container>
                  <ng-template #startDateLabel>
                    {{ webinar.startDate | date: 'mediumDate' }}
                  </ng-template>
                </div>
              </div>
              <div class="status-label" [ngClass]="{
                  completed: webinar.status === 'Completed',
                  open: webinar.status === 'Open',
                  closed: webinar.status === 'Closed'
                }">
                {{ webinar.status }}
              </div>
            </div>
          </mat-expansion-panel-header>

          <div class="webinar-actions" *ngIf="hasVideo(webinar)">
            <button type="button" class="btn-watch-video" (click)="openWatch(webinar)">
              <mat-icon class="btn-icon">play_circle</mat-icon> Watch
            </button>
            <button type="button" class="btn-share-video" (click)="openShare(webinar)">
              <mat-icon class="btn-icon">share</mat-icon> Share
            </button>
          </div>

          <div class="webinar-seats-wrapper">
            <div class="seat-card" *ngFor="let row of webinar.webinarSeats">
              <div class="row">
                <div class="col-md-4">
                  <span class="seat-label">Seat Number:</span>
                  <span class="seat-value">{{ row.seatNumber }}</span>
                </div>
                <div class="col-md-4">
                  <span class="seat-label">Seat Owner:</span>
                  <span class="seat-value">{{ row.seatOwner }}</span>
                </div>
                <div class="col-md-4">
                  <span class="seat-label">Purchase Date:</span>
                  <span class="seat-value">
                    {{ row.purchaseDate | date: 'mediumDate' }}
                    <mat-icon class="check-icon" *ngIf="row.seatId === webinar.selectedSeatId">check_circle</mat-icon>
                  </span>
                </div>
                <div class="col-md-4">
                  <span class="seat-label">Seat Price:</span>
                  <span class="seat-value">{{ row.cost | currency }}</span>
                </div>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</div>